<template>
  <v-row>
    <v-col cols="12">
      <Filtro />
    </v-col>
    <v-col cols="12" sm="12" md="4">
      <TotalLeads />
    </v-col>
    <v-col cols="12" sm="12" md="4">
      <TempoMedioAtendimento />
    </v-col>
    <v-col cols="12" sm="12" md="4">
      <TotalLeadsAtrasados />
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="seeChart">
      <LeadsByStatus />
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="seeChart">
      <LeadsByTemperatura />
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="seeChart">
      <FormasPagamentoLeads />
    </v-col>
    <v-col cols="12" v-if="seeChart">
      <HistoricoRanks />
    </v-col>
    <v-col cols="12">
      <v-row justify="center">
        <v-col cols="4">
          <h2>Rank Geral do Grupo Cometa em {{ dateRank }}</h2>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <RankLeads v-if="seeChart" />
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <RankNovos v-if="seeChart" />
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <RankUsados v-if="seeChart" />
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <RankConsorcio v-if="seeChart" />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Empresa from "@/services/empresa";

export default {
  name: "Adm",

  components: {
    Filtro: () => import("./components/Filtro"),
    TotalLeads: () => import("../components/TotalLeads"),
    TempoMedioAtendimento: () => import("../components/TempoMedioAtendimento"),
    TotalLeadsAtrasados: () => import("../components/TotalLeadsAtrasados"),
    LeadsByStatus: () => import("../components/LeadsByStatus"),
    LeadsByTemperatura: () => import("../components/LeadsByTemperatura"),
    FormasPagamentoLeads: () => import("../components/FormasPagamentoLeads"),
    HistoricoRanks: () => import("../components/HistoricoRanks"),
    RankLeads: () => import("../components/RankLeads"),
    RankNovos: () => import("../components/RankNovos"),
    RankUsados: () => import("../components/RankUsados"),
    RankConsorcio: () => import("../components/RankConsorcio")
  },

  data() {
    return {
      seeChart: false,
      serviceEmpresa: new Empresa()
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getEmpresas"]),

    dateRank() {
      const date = new Date();
      const month = date.toLocaleString("default", {
        month: "long"
      });
      return month;
    }
  },

  methods: {
    ...mapActions("dashboard", ["setEmpresas"]),

    async empresas() {
      try {
        const response = await this.serviceEmpresa.getAll();
        this.setEmpresas(response);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    }
  },

  async mounted() {
    try {
      if (this.getEmpresas.length == 0) {
        await this.empresas();
      }
      this.seeChart = true;
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};
</script>
